import ResearchPage from "@/components/products/research/ResearchPage"

type Props = {}

const index = (_props: Props) => {
  return <ResearchPage />
}

export default index
